import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=522b6f68&"
import script from "./AuthLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports